import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NoteForm from '../../../components/forms/NoteForm';
import { useNoteApi } from '../../../hooks/useNoteApi';
import { useNavigate, useParams } from 'react-router-dom';
import { NoteDTO } from '../../../services/apiClient';

const NoteEdit: React.FC = () => {
  const { getById, edit } = useNoteApi();
  const [entityData, setEntityData] = useState<NoteDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Notes', href: '/admin/notes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Note data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/notes');
    } catch (error) {
      console.error('Error updating Note:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/notes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Main.Note.Edit'
    >
        {entityData ? (
          <NoteForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/notes')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default NoteEdit;